import { pick } from 'lodash';
import { useEffect, useState } from 'react';
export function useSize(elementRef) {
    const [size, setSize] = useState();
    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setSize(pick(entry.contentRect, ['width', 'height']));
            }
        });
        if (elementRef.current) {
            observer.observe(elementRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [elementRef]);
    return size;
}
//# sourceMappingURL=useSize.js.map